import { useState, forwardRef, useEffect } from "react";

import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Slide,
  TextField,
  Typography,
} from "@mui/material";

import { useSelector } from "react-redux";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";
import { submittedQuesAnsTable } from "../../config/grid-column-defs.js";
import { getQuestionAnswersList } from "../../api/questionsAnswers.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";

export default function SubmittedQuesAns() {
  const { data: user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [caseTypeFilter, setCaseTypeFilter] = useState("");
  const errorHandler = useErrorHandler();
  const [questionsTableRefreshCount, setQuestionsTableRefreshCount] =
    useState(0);
  function refreshQuestionsTable() {
    setQuestionsTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    refreshQuestionsTable();
  }, [caseTypeFilter]);

  async function getQuestionTableData(limit, offset) {
    try {
      const { data } = await getQuestionAnswersList(user.token, {
        limit,
        offset,
        type: caseTypeFilter,
      });
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      console.log(error);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Paper className="odr-card">
        <Box>
          <Box
            p={2}
            display="flex"
            justifyContent="space-between"
            className="odr-card-header"
          >
            <Grid
              container
              spacing={1}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <Typography className="heading-title">
                  Questions/Answers
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <TextField
                    size="small"
                    // className={classes.textfeild}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Case Type"
                    value={caseTypeFilter}
                    onChange={(e) => {
                      setCaseTypeFilter(e.target.value);
                    }}
                    fullWidth
                  />
                )}
              </Grid>
            </Grid>
          </Box>
          <div className="odr-main-table">
            <AgGridPaginatedTable
              getTableRows={getQuestionTableData}
              columns={submittedQuesAnsTable}
              perPage={10}
              refreshCounter={questionsTableRefreshCount}
            />
          </div>
        </Box>
      </Paper>
    </>
  );
}
